"use client";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { VIEW_DETAILS_COLORS } from "./viewDetailsButtonColors";

export function ToggleExternalLinkButton({ type, url }) {
  switch (type) {
    case "commercial_exhibitors":
      return (
        <Button
          className="w-full"
          size="xs"
          customColors={VIEW_DETAILS_COLORS}
        >
          <Link target="_blank" href={url}>
            View Details
          </Link>
        </Button>
      );
    default:
      return (
        <Button
          className="w-full"
          size="xs"
          customColors={VIEW_DETAILS_COLORS}
        >
          <Link target="_blank" href={url}>
            View Details
          </Link>
        </Button>
      );
  }
}
